const mapperPdiToAPI = form => {
    const { title, period, description, tags, user_id } = form

    return {
        title,
        period_id: period.value,
        description,
        tag_id: tags.map(tag => tag.value),
        user_id: user_id !== null && user_id !== undefined ? user_id : '',
    }
}

export { mapperPdiToAPI }
